export const formMessage = {
    required: 'This field is required!'
}
